import React, { useRef, useEffect } from "react";

const CustomScrollToBottom = ({style}) => {
  const divRef = useRef(null);

  useEffect(() => {
    divRef.current.scrollIntoView({ behavior: "smooth" });
  });

  return <div style={style} ref={divRef} />;
};

export default CustomScrollToBottom;
